<div class="wrapper">
  <div class="top-bar">
    <div class="content">
      <span (click)="home()">
        <img class="h-18" src="assets/images/icon/chevronleft.svg" />
        {{ translations['back_label'] }}
      </span>
    </div>
    <div>
      <div class="content"></div>
    </div>
    <select
      [value]="currentLanguage"
      (change)="languageChange($event)"
      class="select-dropdown"
    >
      <option
        *ngFor="let option of languageOptions"
        [value]="option?.value"
        [selected]="option.value === currentLanguage"
      >
        {{ option.value }}
      </option>
    </select>
  </div>
  <div class="main pt-1">
    <div class="overflow-scroll p-3 header">
      <h2 class="header-text">{{ translations['troubleshooting'] }}</h2>
      <div class="label pt-2">
        {{ translations['get_machine_fixed'] }}
      </div>
      <div class="info">
        {{ translations['estimated_time'] }}
      </div>
      <div class="pt-4 desc">
        {{ translations['troubleshoot_desc'] }}
      </div>
    </div>

    <div class="d-grid gap-2 btn-container">
      <button
        type="button"
        class="next btn btn-primary btn-block"
        (click)="start()"
      >
        {{ translations['start'] }}
      </button>
    </div>
  </div>
</div>
